const ENV = {
  mapboxKey() {
    return "";
  }
};

export default ENV;